import { c as _c } from "react/compiler-runtime";
import { SphereIconButton } from "@components/common/sphere-icon-button";
import DateAdapter from "@date-io/luxon";
import { Box, Stack } from "@mui-wrapper";
import { ChevronLeftIcon, ChevronRightIcon, Text } from "@flat-ui";

/** Content to show above the calendar view, i.e. month with next, previous month buttons */
export function FaroDatePickerHeader(t0) {
  const $ = _c(15);
  const {
    currentMonth,
    onMonthChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      justifyContent: "space-between",
      padding: "8px 16px",
      alignItems: "center"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== currentMonth || $[2] !== onMonthChange) {
    t2 = <Stack spacing={1} direction="row"><SphereIconButton component={ChevronLeftIcon} onClick={() => onMonthChange(new DateAdapter().addMonths(currentMonth, -1))} /></Stack>;
    $[1] = currentMonth;
    $[2] = onMonthChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== currentMonth) {
    t3 = currentMonth.toFormat("MMMM yyyy");
    $[4] = currentMonth;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <Text variant="bodyM">{t3}</Text>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== currentMonth || $[9] !== onMonthChange) {
    t5 = <Stack spacing={1} direction="row"><SphereIconButton component={ChevronRightIcon} onClick={() => onMonthChange(new DateAdapter().addMonths(currentMonth, 1))} /></Stack>;
    $[8] = currentMonth;
    $[9] = onMonthChange;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t4 || $[13] !== t5) {
    t6 = <Box component="div" sx={t1}>{t2}{t4}{t5}</Box>;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}